import React  from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import AdminLevelTwoBasicInfoComponent from '../../admin-level2/components/admin-level-two-basic-info';
import AdminLevelThreeBasicInfoComponent from './admin-level-three-basic';

export const AdminLevelThreeComponent = ({handleInnerChange,handleInnerFormChange,selectedCategory,globalAdmin,
 back,handleFormSubmit,parentAdmin}: any) => {
console.log(globalAdmin,"ParentAdminLayerId")
  const tabItems=[
    {
        id:1,
        title:'New Admin Level 3',
        component:<AdminLevelThreeBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        handleInnerChange={handleInnerChange}
        selectedCategory={selectedCategory}
        globalAdmin={globalAdmin}
        parentAdmin={parentAdmin}
        />,
    isVisible:true,
    }
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default AdminLevelThreeComponent;
